var exports = {
  "t8": "MobileFriendRequestItem.module__requestItem___OU4wdl",
  "eF": "MobileFriendRequestItem.module__userInfo___OU4wdl",
  "nT": "MobileFriendRequestItem.module__userName___OU4wdl",
  "G2": "MobileFriendRequestItem.module__requestStatus___OU4wdl",
  "hP": "MobileFriendRequestItem.module__actionButton___OU4wdl" + " " + __webpack_require__(180357)["AS"] + " " + __webpack_require__(180357)["ik"],
  "RK": "MobileFriendRequestItem.module__iconSize___OU4wdl",
};

module.exports = exports;
